var DeviceGpsSetting;
(function (DeviceGpsSetting) {
    DeviceGpsSetting["Disabled"] = "Disabled";
    DeviceGpsSetting["Low"] = "Low";
    DeviceGpsSetting["Medium"] = "Medium";
    DeviceGpsSetting["High"] = "High";
})(DeviceGpsSetting || (DeviceGpsSetting = {}));
export default DeviceGpsSetting;
